import React, { useEffect } from 'react';
import { CheckCircleIcon, LinkIcon, ArchiveBoxIcon } from '@heroicons/react/24/outline';

const ConfirmationNotification = ({ 
  show, 
  message, 
  type = 'success', 
  onComplete,
  duration = 3000 
}) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onComplete?.();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [show, duration, onComplete]);

  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case 'link':
        return <LinkIcon className="w-8 h-8 text-blue-600" />;
      case 'archive':
        return <ArchiveBoxIcon className="w-8 h-8 text-green-600" />;
      default:
        return <CheckCircleIcon className="w-8 h-8 text-green-600" />;
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'link':
        return 'bg-blue-50 border-blue-200';
      case 'archive':
        return 'bg-green-50 border-green-200';
      default:
        return 'bg-green-50 border-green-200';
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center z-50 p-4">
      <div className={`transform transition-all duration-300 ${show ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
        <div className={`bg-white rounded-lg shadow-xl border-2 ${getBackgroundColor()} p-6 max-w-md w-full`}>
          <div className="flex flex-col items-center text-center space-y-4">
            {/* Icon */}
            <div className="flex-shrink-0">
              {getIcon()}
            </div>
            
            {/* Message */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Success!
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {message}
              </p>
            </div>
            
            {/* Auto-close indicator */}
            <div className="w-full bg-gray-200 rounded-full h-1">
              <div 
                className="bg-primary-500 h-1 rounded-full transition-all ease-linear"
                style={{
                  width: '100%',
                  animation: `shrink ${duration}ms linear forwards`
                }}
              />
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes shrink {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>
    </div>
  );
};

export default ConfirmationNotification;